import { formatCurrencyPipeText } from "@/core/pipes/format-currency.pipe";
import { TeamOutlined, MobileOutlined, WalletOutlined, FileTextOutlined } from "@ant-design/icons";
import { Row, Col, Card, Statistic } from "antd";

interface SummaryCardsProps {
    totalCustomers: number,
    totalAppUsers: number,
    totalDeposits: number,
    totalBills: number,
    selectedMonth: string,
    selectedYear: string,
}
export const SummaryCards: React.FC<SummaryCardsProps> = ({ totalCustomers, totalAppUsers, totalDeposits, totalBills, selectedMonth, selectedYear }) => {
    const navigateToCustomers = () => {
        // Navigate to customers page
    };

    const navigateToDeposits = () => {
        // Navigate to deposits page
    };

    const navigateToBills = () => {
        // Navigate to bills page
    };

    return (
        <Row gutter={24}>
            <Col span={12}>
                <Card bordered>
                    <div style={{ textAlign: 'center', cursor: 'pointer', padding: '16px' }} onClick={navigateToCustomers}>
                        <div style={{ background: 'rgba(24, 144, 255, 0.1)', padding: '16px', borderRadius: '50%', width: '64px', height: '64px', margin: '0 auto 16px' }}>
                            <TeamOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                        </div>
                        <Statistic title="Tổng khách hàng" value={totalCustomers.toLocaleString()} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
                    </div>
                </Card>
                <div className="mb-6"></div>
                <Card bordered>
                    <div style={{ textAlign: 'center', cursor: 'pointer', padding: '16px' }} onClick={navigateToCustomers}>
                        <div style={{ background: 'rgba(82, 196, 26, 0.1)', padding: '16px', borderRadius: '50%', width: '64px', height: '64px', margin: '0 auto 16px' }}>
                            <MobileOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
                        </div>
                        <Statistic title="Người dùng App" value={totalAppUsers.toLocaleString()} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
                    </div>
                </Card>
            </Col>
            <Col span={12}>
                <Card bordered>
                    <div style={{ textAlign: 'center', cursor: 'pointer', padding: '16px' }} onClick={navigateToDeposits}>
                        <div style={{ background: 'rgba(250, 173, 20, 0.1)', padding: '16px', borderRadius: '50%', width: '64px', height: '64px', margin: '0 auto 16px' }}>
                            <WalletOutlined style={{ fontSize: '32px', color: '#faad14' }} />
                        </div>
                        <Statistic title="Đặt cọc" value={`${formatCurrencyPipeText(totalDeposits / 1000000)}M VNĐ`} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
                    </div>
                </Card>
                <div className="mb-6"></div>
                <Card bordered>
                    <div style={{ textAlign: 'center', cursor: 'pointer', padding: '16px' }} onClick={navigateToBills}>
                        <div style={{ background: 'rgba(245, 34, 45, 0.1)', padding: '16px', borderRadius: '50%', width: '64px', height: '64px', margin: '0 auto 16px' }}>
                            <FileTextOutlined style={{ fontSize: '32px', color: '#f5222d' }} />
                        </div>
                        <Statistic title={`Hoá đơn ${selectedMonth}/${selectedYear}`} value={totalBills.toLocaleString()} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
                    </div>
                </Card>
            </Col>
        </Row>
    );
};
